/*
 * Copyright (C) 2025-2026 The Klangmotor Authors (see AUTHORS.MD)
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package io.peekandpoke.klang.audio_bridge.analyzer

import org.khronos.webgl.Float32Array

actual typealias AnalyzerBuffer = Float32Array

actual fun createAnalyzerBuffer(size: Int): AnalyzerBuffer = Float32Array(size)
